import { gql } from '@apollo/client';

import { serviceAgreement_fields } from './service';
import { equipment_fields } from './equipment';
import { issue_fields } from './issues';
import { location_fields, latest_location_fields } from './positionDevice';
import { FR_MACHINE_TYPE_FIELDS } from './fragments/machine';
import { FR_ISSUE_LIST_FIELDS, FR_ISSUES_FIELDS } from './fragments/issue';

export const machineFields = `
	MachineId
	Name
	SerialNbr
	Created
	Updated
	InServiceDate
    OutOfServiceDate
    PurchaseVendor
    WarrantyExpirationDate
    PurchaseDate
	CalibrationDate
	ExpirationDate
	Organization {
		OrganizationId
		Name
		OrganizationStateType {
			OrganizationStateTypeId
		}
		Bin
	}
	MachineTaskType {
		MachineTaskTypeId
		TaskType {
			TaskTypeId
			  Name
			  Abbr
			  TaskGroup
		}
	}
	MachineClass {
		Name
		MachineClassId
	}
	MachineType {
		Name
		MachineTypeId
	}
	MachineModel {
		MachineModelId
		Name
	}
	Asset {
		AssetName
		AssetType
	  }
	Access{
		Read
		Create
		Delete
		Update
	}
	Width
	MaximumWidth
	MaximumHeight
	TransportHeight
	TransportLength
	MassFrontRight
	MassFrontLeft
	MassRearRight
	MassRearLeft
	TotalMass
	OperationHours {
		MachineMetricId
		Max
		Latest
		Date
	   	Source
   	}
`;

const machineTasks = `

TaskResource {
	TaskResourceId
	Project {
	  ProjectId
	  Name
	  ProjectNbr
	}
	Task {
	  TaskId
	  TaskStatus {
		TaskStatusId
		Name
	  }
	  Location {
		Name
		Point {
		  PointId
		}
	  }
	  TaskType {
		Name
		Abbr
		TaskGroup
		TaskTypeId
	  }
	}
  }`;

const issueFields = `Issues { ` + issue_fields + `}`;

const agreementFields = `ServiceAgreement { ` + serviceAgreement_fields + `}`;

const issueFieldsmachine_equipment_fields =
    `
  MachineEquipment {
	MachineEquipmentId
	Count
	Equipment {` +
    equipment_fields +
    `}
  }`;

export const GET_MACHINE_LOCATIONDATA = gql(
    `
query machineById($MachineId: Int!, $StartDate: Date!, $EndDate: Date!) {
	machineById( data: { MachineId: $MachineId}) {
		MachineId
		MachineLocation( data: { Update: true, StartDate: $StartDate EndDate: $EndDate}) { 
			` +
        location_fields +
        `
		}
	}
}`
);

export const GET_MACHINE_ISSUES = gql(
    `query machineById($MachineId: Int!) { machineById(data:{MachineId:$MachineId}) {` +
        issueFields +
        `}}`
);

export const GET_MACHINE_AGREEMENTS = gql(
    `query machineById($MachineId: Int!) { machineById(data:{MachineId:$MachineId}) {` +
        agreementFields +
        `}}`
);

export const GET_MACHINES = gql(
    `query get_machines { machines {` +
        machineFields +
        issueFields +
        issueFieldsmachine_equipment_fields +
        latest_location_fields +
        `}}`
);

export const GET_MACHINES_FOR_ORGANIZATION = gql(
    `query machineByOrganizationId($OrganizationId: Int!) { machineByOrganizationId(data:{ OrganizationId: $OrganizationId}) { ` +
        machineFields +
        issueFields +
        issueFieldsmachine_equipment_fields +
        latest_location_fields +
        ` } }`
);

export const GET_MACHINE_BY_ID = gql(
    ` query machineById($MachineId: Int!) { machineById(data:{MachineId:$MachineId}) { ` +
        machineFields +
        issueFields +
        issueFieldsmachine_equipment_fields +
        `}}`
);

export const GET_MACHINE_TASK_FOR_PLANNING = gql(
    `query machines { machines { ` + machineFields + machineTasks + ` } }`
);

export const GET_MACHINE_EQUIPMENTS_FOR_PLANNING = gql(
    `query machineByOrganizationId($OrganizationId: Int!) { machineByOrganizationId(data:{ OrganizationId: $OrganizationId}) { ` +
        machineFields +
        issueFieldsmachine_equipment_fields +
        ` } }`
);

export const CREATE_MACHINE = gql(
    `
mutation createMachine($Name: String!, $SerialNbr: String!, $MachineModelId: Int!, $MachineTypeId: Int!, $MachineClassId: Int!, $OrganizationId: Int!, $InServiceDate: Date, $OutOfServiceDate: Date, $WarrantyExpirationDate: Date, $PurchaseDate : Date, $PurchaseVendor: String, $TaskTypeIds: [Int!], 
	$Width: String, $MaximumWidth: String, $MaximumHeight: String, $TransportHeight: String, $TransportLength: String, $MassFrontRight: String, $MassFrontLeft: String, $MassRearRight: String, $MassRearLeft: String, $TotalMass: String) {
	
	createMachine( data:{
		Name: $Name, 
		SerialNbr: $SerialNbr,
		MachineModelInputType: { 
			MachineModelId: $MachineModelId, 
		},
		MachineTypeInputType: { 
			MachineTypeId: $MachineTypeId,  
		},
		MachineClassInputType: { 
			MachineClassId: $MachineClassId
		},
		OrganizationId: $OrganizationId
		InServiceDate: $InServiceDate
		OutOfServiceDate: $OutOfServiceDate
		PurchaseVendor: $PurchaseVendor
		WarrantyExpirationDate: $WarrantyExpirationDate
		PurchaseDate: $PurchaseDate
		TaskTypeIds: $TaskTypeIds
		Width: $Width
		MaximumWidth: $MaximumWidth
		MaximumHeight: $MaximumHeight
		TransportHeight: $TransportHeight
		TransportLength: $TransportLength
		MassFrontRight: $MassFrontRight
		MassFrontLeft: $MassFrontLeft
		MassRearRight: $MassRearRight
		MassRearLeft: $MassRearLeft
		TotalMass: $TotalMass
	}) 
	{` +
        machineFields +
        issueFields +
        issueFieldsmachine_equipment_fields +
        latest_location_fields +
        `}}`
);

export const UPDATE_MACHINE = gql(
    `
mutation updateMachine($MachineId: Int!, $Name: String, $SerialNbr: String, $CalibrationDate: Date, $MachineModelId: Int, $MachineTypeId: Int, $MachineClassId: Int, $OrganizationId: Int, $InServiceDate: Date, $OutOfServiceDate: Date, $WarrantyExpirationDate: Date, $PurchaseDate : Date, $PurchaseVendor: String, $TaskTypeIds: [Int!],
	$Width: String, $MaximumWidth: String, $MaximumHeight: String, $TransportHeight: String, $TransportLength: String, $MassFrontRight: String, $MassFrontLeft: String, $MassRearRight: String, $MassRearLeft: String, $TotalMass: String) {
	updateMachine( data:{
		MachineId: $MachineId
		Name: $Name
		SerialNbr: $SerialNbr
		CalibrationDate: $CalibrationDate
		MachineModelId: $MachineModelId
		MachineTypeId: $MachineTypeId
		MachineClassId: $MachineClassId
		OrganizationId: $OrganizationId
		InServiceDate: $InServiceDate
		OutOfServiceDate: $OutOfServiceDate
		PurchaseVendor: $PurchaseVendor
		WarrantyExpirationDate: $WarrantyExpirationDate
		PurchaseDate: $PurchaseDate
		TaskTypeIds: $TaskTypeIds
		Width: $Width
		MaximumWidth: $MaximumWidth
		MaximumHeight: $MaximumHeight
		TransportHeight: $TransportHeight
		TransportLength: $TransportLength
		MassFrontRight: $MassFrontRight
		MassFrontLeft: $MassFrontLeft
		MassRearRight: $MassRearRight
		MassRearLeft: $MassRearLeft
		TotalMass: $TotalMass
	}) 
	{` +
        machineFields +
        issueFields +
        issueFieldsmachine_equipment_fields +
        latest_location_fields +
        `}}`
);

export const DELETE_MACHINE = gql(`
mutation deleteMachine($MachineId: Int!) {
	deleteMachine(data:{
		MachineId: $MachineId
	})
}
`);

export const GET_MACHINE_LIST = gql`
    query getMachinesForTaskList {
        machines {
            MachineId
            Name
            SerialNbr
            MachineClass {
                Name
                MachineClassId
            }
            MachineType {
                Name
                MachineTypeId
            }
            MachineModel {
                MachineModelId
                Name
            }
            Asset {
                AssetName
                AssetType
            }
            Access {
                Read
                Create
                Delete
                Update
            }
            MachineTaskType {
                MachineTaskTypeId
                TaskType {
                    TaskTypeId
                    Name
                    Abbr
                    TaskGroup
                }
            }
        }
    }
`;

export const GET_MACHINE_METRICS = gql`
    query machineMetric($MachineId: Int!) {
        machineMetric(data: { MachineId: $MachineId }) {
            MetricType
            Latest
        }
    }
`;

export const GET_MACHINE_MODELS = gql`
    query get_machineModels {
        machineModels {
            MachineModelId
            Name
        }
    }
`;

export const GET_MACHINE_TYPES = gql`
    query get_machineTypes {
        machineTypes {
            ...fr_MachineTypeFields
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
`;

export const GET_MACHINE_CLASSES = gql`
    query get_machineClasses {
        machineClasses {
            MachineClassId
            Name
        }
    }
`;

export const REFETCH_MACHINE_FAULTCODES = gql(`
	mutation refreshMachineFaultCodes($MachineId: Int!) {
		refreshMachineFaultCodes(data:{
			MachineId: $MachineId
		})
	}
`);

export const MACHINE_LOCATION = gql`
    query getMachineLocation($MachineId: Int!, $StartDate: Date!, $EndDate: Date!) {
        machineLocation(data: { MachineId: $MachineId, StartDate: $StartDate, EndDate: $EndDate }) {
            PositioningDeviceLocationId
            PositioningDevice {
                PositioningDeviceId
                Name
            }
            Lat
            Long
            Timest
            Timestamp
            Created
            Updated
        }
    }
`;

export const MACHINE_ISSUES = gql`
    query getmachineIssues($MachineId: Int!, $State: [IssueStatusEnum!], $IssueType: IssueTypeEnum!) {
        machineIssues(data: { MachineId: $MachineId, State: $State, IssueType: $IssueType }) {
            ...fr_IssueListFields
        }
    }
    ${FR_ISSUE_LIST_FIELDS}
`;
